import ProductComparisonChart from "~/components/ProductComparisonChart";
import { getCommonSliceProps, getRichText } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

export function mapSliceToProps(slice, externalData) {
  const { primary, items } = slice;

  const { products = [] } = externalData;

  const props = {
    ...getCommonSliceProps(slice),

    cards: items.map((item) => {
      const product =
        item.product.uid && products.find((pr) => pr.key === item.product.data.key);
      const cable =
        item.cable?.uid && products.find((pr) => pr.key === item.cable.data.key);
      const speaker_units =
        item.speaker_units?.uid &&
        products.find((pr) => pr.key === item.speaker_units.data.key);
      const headband =
        item.headband?.uid && products.find((pr) => pr.key === item.headband.data.key);
      const earpads =
        item.earpads?.uid && products.find((pr) => pr.key === item.earpads.data.key);

      return {
        product,
        cable,
        speaker_units,
        headband,
        earpads,

        sound_profile: item.sound_profile,
        summary: getRichText(item.summary),

        w_link: getRichText(item.w_link),
        w_link_compatibility: getRichText(item.w_link_compatibility),
        bluetooth: getRichText(item.bluetooth),
        battery: getRichText(item.battery),
        microphone: getRichText(item.microphone),

        diaphragm: getRichText(item.diaphragm),
        power: getRichText(item.power),
        spl: getRichText(item.spl),

        weight: getRichText(item.weight),
      };
    }),
  };

  return props;
}

export default connectSlice(mapSliceToProps)(ProductComparisonChart);
